import { useRef, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { MonthInput } from '@/kit/DatePickers/MonthInput';
import { MonthRangeCalendar } from '@/kit/DatePickers/calendar/MonthRangeCalendar';
import { DATE_REQUEST } from '@/helpers/common';
import s from './index.module.scss';

export const MonthRangePicker = ({
  range = [null, null],
  setRange,
  minDate,
  maxDate,
  hideCalendar,
}) => {
  const { t } = useTranslation('reports');
  const ref = useRef();
  const [open, setOpen] = useState(false);

  useOutsideClick(ref, () => setOpen(false), open);

  return (
    <div className={s.wrapper} ref={ref}>
      <div className="f-small-accent" style={{ color: '#17232D' }}>
        {t('date_picker.date_range')}
      </div>
      <div className={s.inputs}>
        <MonthInput
          value={range[0]}
          onChange={date =>
            setRange([
              moment(date).startOf('month').format(DATE_REQUEST),
              range[1],
            ])
          }
          onFocusIn={() => setOpen(true)}
        />
        <MonthInput
          value={range[1]}
          onChange={date =>
            setRange([
              range[0],
              moment(date).endOf('month').format(DATE_REQUEST),
            ])
          }
          onFocusIn={() => setOpen(true)}
        />
      </div>
      {open && !hideCalendar && (
        <div className={s.calendar}>
          <MonthRangeCalendar
            range={range}
            minDate={minDate}
            maxDate={maxDate}
            onRangeChange={range => {
              setRange(range);
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};
